export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const sections = [
    { title: '快速导航', links: [
      { label: '首页', href: '#hero' },
      { label: '最新爆料', href: '#updates' },
      { label: '热门话题', href: '#topics' },
      { label: '热度榜单', href: '#ranking' },
    ]},
    { title: '特色栏目', links: [
      { label: '专题索引', href: '#index' },
      { label: '焦点专题', href: '#carousel' },
      { label: '精选爆料', href: '#cards' },
      { label: '热门视频', href: '#media' },
    ]},
    { title: '帮助中心', links: [
      { label: '常见问答', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '移动入口', href: '#app' },
      { label: '关于我们', href: '#about' },
    ]},
  ];

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="text-xl font-bold mb-4 block cursor-pointer">黑料吃瓜</a>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              📰 黑料吃瓜网是行业领先的娱乐资讯聚合平台，每日提供最新爆料内容。本站提供多条访问线路（线路一二三），确保用户随时随地流畅浏览。收藏黑料吃瓜官网入口，精彩爆料不错过。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-700 text-background-50 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-700 text-background-50 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-700 text-background-50 cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </span>
            </div>
          </div>

          {sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold mb-4 text-background-50">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-sm text-foreground-300 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-700 pt-8 mb-8">
          <h4 className="text-sm font-semibold mb-4 text-background-50">合作伙伴</h4>
          <div className="flex flex-wrap gap-4">
            <div className="px-4 py-2 rounded-lg bg-foreground-800 text-xs text-foreground-400">合作伙伴区域</div>
          </div>
        </div>

        <div className="border-t border-foreground-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            &copy; {new Date().getFullYear()} 黑料吃瓜网 - 黑料吃瓜官网入口 | 黑料吃瓜最新网址链接 · 黑料吃瓜导航首页 | 黑料吃瓜线路一二三
          </p>
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            本站内容仅供娱乐参考
          </p>
        </div>
      </div>
    </footer>
  );
}